<template>
  <dispatch />
</template>

<script>
import Dispatch from "@/components/3pl/Operations/Dispatch/Dispatch";
export default {
  components: {
    Dispatch,
  },
};
</script>

<style></style>
